/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S10_P1_BInputs */

const tr_kullanim_s10_p1_b = /** @type {(inputs: Kullanim_S10_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sayfamızdadır.`)
};

const en_kullanim_s10_p1_b = /** @type {(inputs: Kullanim_S10_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page.`)
};

const de_kullanim_s10_p1_b = /** @type {(inputs: Kullanim_S10_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`einsehen.`)
};

const ru_kullanim_s10_p1_b = /** @type {(inputs: Kullanim_S10_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`нашего сайта.`)
};

/**
* | output |
* | --- |
* | "page." |
*
* @param {Kullanim_S10_P1_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s10_p1_b = /** @type {((inputs?: Kullanim_S10_P1_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S10_P1_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s10_p1_b(inputs)
	if (locale === "de") return de_kullanim_s10_p1_b(inputs)
	if (locale === "ru") return ru_kullanim_s10_p1_b(inputs)
	return tr_kullanim_s10_p1_b(inputs)
});